import { NgModule } from '@angular/core';
import { ConfirmationPageTextFactory } from './confirmation-page-text-factory';

import { InsertVariableToStringPipe } from './insert-variable-to-string.shared.pipe';

@NgModule({
    declarations: [
        InsertVariableToStringPipe
    ],
    exports: [
        InsertVariableToStringPipe
    ],
    providers: [
        ConfirmationPageTextFactory
    ]
})
export class InsertVariableToStringModule { }
